// We separate the controller logic so we can use it for selects

import angular from 'angular';

// that are nested within other directives
SelectController.$inject = ['$scope'];

export function SelectController(scope) {
    scope.isActive = false;

    scope.selectOption = function (event) {
        // Update selected value text
        scope.selectedOptionText = angular.element(event.target).text().trim();

        let options = event.target.parentElement;
        let target = event.target;

        if (event.target.tagName === 'A') {
            options = options.parentElement;
            target = target.parentElement;
        }

        // Update current_option class
        angular.element(options.children).removeClass('is_active');
        angular.element(target).addClass('is_active');
    };
}

// TODO: replace this directive/controller setup with a component.
// in many cases the injected controller is no longer being used. 
export function SelectDirective() {
    return {
        scope: {},
        transclude: true,
        link: function (scope, element, attrs, ctrl, transclude) {
            // Use directive's scope for the transcluded info, instead of the controller's scope.
            transclude(scope, function (clone) {
                element.append(clone);
            });
        },
        controller: 'tnSelectController',
    };
}
